<template>
  <v-list-item 
    @click="$emit('onSelected', $event, value)"
    :key="itemId"
    :value="String(value)"
    class="list-item-container"
  >
    <v-list-item-content>
      <v-list-item-title>{{ itemTitle }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="actionCompleted !== null">
      <v-icon v-if="actionCompleted" color="success">mdi-checkbox-marked-circle-outline</v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemWithAction',
  props: {
    itemId: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    itemTitle: {
      type: String
    },
    actionCompleted: {
      type: Boolean,
      default: null
    }
  },
};
</script>

<style scoped>
.list-item-container:hover:before {
  border-radius: 10px;
  padding: 0;
}
</style>